import './QuickCart.scss';

import {
    Button,
    Icon,
} from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import React, { useEffect, useState } from 'react';
import {
    useCartContent,
    useCartContext,
} from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/cart';

import { CSSTransition } from 'react-transition-group';
import CartItem from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/CartItem';
import LocalePrice from '@progymedia/gatsby-theme-boutik-ecommerce/src/utils/LocalePrice';
import { useBoutikService } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/boutikService';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

// import CartItem from './CartItem';
// import LocalePrice from '../../utils/LocalePrice';

const svgCart =
    'M9.384,19.186a1.7,1.7,0,1,1-1.7-1.7,1.7,1.7,0,0,1,1.7,1.7Zm11.355,0a1.7,1.7,0,1,1-1.7-1.7A1.7,1.7,0,0,1,20.739,19.186Zm0-7.381V4.992H7.113A1.136,1.136,0,0,0,5.977,3.856H2.571V4.992H4.842L5.695,12.3a2.271,2.271,0,0,0,1.418,4.044H20.739V15.211H7.113a1.136,1.136,0,0,1-1.136-1.136s0-.008,0-.012L20.739,11.8Z';

export const QuickCartIcon = () => {
    const { setQuickCartVisible } = useCartContext();
    const [cart] = useCartContent();
    const { isAuthenticated } = useBoutikService();

    return (
        <div
            className='cartIcon'
            onClick={() => {
                // todo except shopping-cart
                setQuickCartVisible(true);
            }}
        >
            <Icon
                d={svgCart}
                size='20'
                viewbox='0 0 18.169 17.033'
                transform='translate(-2.571 -3.856)'
            />

            {isAuthenticated && (
                <div className='cartCountBadge'>
                    {cart?.total_quantity ? cart.total_quantity : 0}
                </div>
            )}
        </div>
    );
};

export function QuickCart() {
    const [loading, setLoading] = useState(false);
    const { isQuickCartVisible, setQuickCartVisible } = useCartContext();
    const [cart] = useCartContent();
    const { currentLocale, navigateTranslated } = usePageLocalization();
    const { t } = useTranslation('cart');

    useEffect(() => {
        if (isQuickCartVisible) {
            document.documentElement.style.overflow = 'hidden';
        } else {
            document.documentElement.style.overflow = '';
        }
    }, [isQuickCartVisible]);

    const navigateCloseCart = (to: string) => {
        setQuickCartVisible(false);
        navigateTranslated(to);
    };

    return (
        <>
            <CSSTransition
                in={isQuickCartVisible}
                timeout={300}
                classNames='pageOverlay'
                unmountOnExit
            >
                <div
                    className='pageOverlay'
                    onClick={() => setQuickCartVisible(false)}
                ></div>
            </CSSTransition>

            <CSSTransition
                in={isQuickCartVisible}
                timeout={300}
                classNames='cartPopupMenu'
                unmountOnExit
            >
                <div key='cartPopupMenu' className={`cartPopupMenu cartSide`}>
                    {
                        // basic loading overlay
                        loading && (
                            <div className='overlay cart-loading'>
                                <div className='loader'>
                                    {t('quick-cart.loading')}...
                                </div>
                            </div>
                        )
                    }
                    <div className='qCartHeader'>
                        <Button onClick={() => setQuickCartVisible(false)}>
                            <Icon
                                d='m0 2.03l2-1.99 13.98 13.98 14.02-14.02 2 2-14.02 14.02 13.98 13.98-1.99 2-14.02-14.02-13.99 13.98-1.96-1.96 13.98-13.98z'
                                viewbox='0 0 32 32'
                                size='18'
                            />
                        </Button>

                        {/* maybe: pourrait aussi afficher des messages promo/importants ?  ex.: x$ avant shipping gratuit */}
                        <p className={`q-cart-title`}>
                            {t('quick-cart.title')}
                        </p>
                    </div>
                    <div className='q-cart-content'>
                        {cart?.items?.length ? (
                            // List Cart Items
                            cart.items.map((item) => (
                                <CartItem
                                    item={item}
                                    setLoading={setLoading}
                                    key={item!.id}
                                    className={'list'}
                                />
                            ))
                        ) : (
                            // Empty Cart Notice
                            <div className='cart-empty'>
                                <p>{t('quick-cart.empty')}</p>
                            </div>
                        )}
                    </div>

                    {cart?.total_quantity ? (
                        <div className='q-cart-footer'>
                            <table className='cartPopupMenuTotal'>
                                <tbody>
                                    <tr>
                                        <th>{t('quick-cart.subtotal')}</th>
                                        <td>
                                            {LocalePrice(
                                                currentLocale,
                                                cart.prices!
                                                    .subtotal_excluding_tax!
                                                    .value
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <Button
                                className='qc-checkout'
                                onClick={() => navigateCloseCart('/mycart/')}
                                label={t('quick-cart.pass-order')}
                            />
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </CSSTransition>
        </>
    );
}
